import React from 'react';
import { ICONS, S3BucketConfig } from 'src/common/constants';
import Row from '../Row';
import Document from '../Document';
import FontAwesomeIcon from '../Icon';
import { isImage } from 'src/helpers/CommonHelpers';
import './Documents.scss';

interface DocumentsRepeaterProps {
  documents: any[];
  onDeleteDocument: (document: any) => void;
  onDownload: (image?: string) => void;
  onClick: (index: number, imageOrDocument: string, isImage: boolean) => void;
  user: any;
  from?: string;
}

const DocumentsRepeater = ({
  documents,
  onDeleteDocument,
  onDownload,
  onClick,
  user,
  from,
}: DocumentsRepeaterProps) => {
  const role: string = user.roles[0].role.name;

  return (
    <div className="documents__items">
      <Row>
        {documents.map((d: any, x: number) => (
          <div key={`DR-${from ?? ''}-${x}`}>
            {d.Embed && d.Embed.length > 0 ? (
              <div
                style={{
                  width: '172',
                  height: '130',
                  paddingLeft: '1rem',
                  paddingRight: '1rem',
                }}
              >
                {user.roles[0].role.name === 'Strata Manager' ||
                user.roles[0].role.name === 'Home Owner' ||
                user.roles[0].role.name === 'Realtor' ||
                from === 'keypickup' ? null : (
                  <div style={{ textAlign: 'right' }}>
                    <div
                      onClick={() =>
                        window.confirm(
                          `Are you sure you want to delete the selected file?`
                        ) && onDeleteDocument(d)
                      }
                    >
                      <FontAwesomeIcon
                        glyph="times-circle"
                        weight="regular"
                        size="small"
                      />
                    </div>
                  </div>
                )}
                <div className="documents__item">
                  <div className="container">
                    <div className="h_iframe">
                      <div
                        style={{ height: '180px' }}
                        dangerouslySetInnerHTML={{ __html: `${d.Embed} ` }}
                      />
                    </div>
                  </div>
                  <div
                    className="documents__headline"
                    title={d.name}
                    style={{ paddingLeft: 2 }}
                  >
                    {d.name}
                  </div>
                  <div
                    className="documents__strapline"
                    title={d.description}
                    style={{ paddingLeft: 2 }}
                  >
                    {d.description}
                  </div>
                  <div
                    className="documents__strapline"
                    title={d.itemName}
                    style={{ paddingLeft: 2 }}
                  >
                    {d.itemName}
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ padding: '1rem' }}>
                <Document
                  key={x}
                  headline={
                    d.documentType === 'Onboarding'
                      ? d.image && d.image.split(S3BucketConfig.url)
                      : d.name
                  }
                  strapline={
                    d.type === 'Video'
                      ? d.description
                      : d.type === 'Other'
                        ? 'General'
                        : d.type
                  }
                  itemName={d.itemName}
                  image={d.image ? d.image : null}
                  onDownload={() =>
                    d.image ? onDownload(d.image) : onDownload()
                  }
                  // onClick is when you click the main part of the tile
                  onClick={() => {
                    // Documents are still stored under object.image. Should update that to "attachment"
                    onClick(x, d.image ?? d.document ?? '', isImage(d.image));
                  }}
                  icon={
                    <FontAwesomeIcon
                      glyph={
                        ICONS[
                          d.type === 'General' || d.type === 'Other'
                            ? 'OtherDoc'
                            : d.type
                        ] as any
                      }
                      weight="light"
                    />
                  }
                  onDelete={
                    role === 'Strata Manager' ||
                    role === 'Home Owner' ||
                    role === 'Realtor' ||
                    from === 'keypickup'
                      ? false
                      : (Document: any) =>
                          window.confirm(
                            `Are you sure you want to delete the selected file?`
                          ) && onDeleteDocument(d)
                  }
                  active={undefined}
                  itemTypeWalkthrough={undefined}
                  small={undefined}
                  onView={undefined}
                  check={undefined}
                  edit={undefined}
                  onEdit={undefined}
                />
              </div>
            )}{' '}
          </div>
        ))}
      </Row>
    </div>
  );
};

export default DocumentsRepeater;
